export const brand = {
  name: 'Beta Express',
  cabinetUrl: 'https://betaex.work/customer_users/sign_in',
  trackingApiUrl: process.env.NODE_ENV === 'development'
    ? '/api/public/v1/global_tracking'
    : 'https://betaex.work/api/public/v1/global_tracking',
  contact: {
    phone: '+7 777 950 00 50',
    phoneHref: 'tel:+77779500050',
    email: 'betaex@mail.ru',
    address: 'г. Алматы, ул. Ниязбекова, дом 33, 050034',
    mapUrl: 'https://yandex.ru/maps/?um=constructor%3Ab5cb1aed0a9f9a603a31a1c2dde7d442080fe9c7e5a70dd998da278f9f6d0cf8&source=constructorStatic',
  },
};

const apiLocales = {
  en: 'en',
  kk: 'kz',
  ru: 'ru',
};

export function buildTrackingApiUrl(code, language) {
  const locale = apiLocales[language] || 'ru';
  return `${brand.trackingApiUrl}/${encodeURIComponent(code)}?locale=${locale}`;
}
